import { render, staticRenderFns } from "./PreferenceAnalysis.vue?vue&type=template&id=20f9b614&scoped=true&"
import script from "./PreferenceAnalysis.vue?vue&type=script&lang=js&"
export * from "./PreferenceAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./PreferenceAnalysis.vue?vue&type=style&index=0&id=20f9b614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f9b614",
  null
  
)

export default component.exports